import ApolloErrorBoundary from '@components/ApolloErrorBoundary';
import { Suspense, type FC } from 'react';
import { TabFallback, type TabProps } from '../common';
import { FormComponent } from './FormComponent';

// TODO
export const AlertConfigurationTab: FC<TabProps> = (props) => {
  return (
    <ApolloErrorBoundary variant="modal">
        <Suspense fallback={<TabFallback onClose={props.onClose} />} >
          <FormComponent {...props} />
        </Suspense>
      </ApolloErrorBoundary>
  );
};
